import { RouteNames } from "../app/routes/types";
import { IForm } from "../store/forms/types";

export interface IgetUrlParams {
    form_id: null | IForm["_id"];
    path: null | string;
}

export interface IGetFormIdFromUrl {
    form_id: string;
}

export const getUrlParams = (): IgetUrlParams => {
    let data: IgetUrlParams = {
        form_id: null,
        path: null,
    };

    const url = window.location;
    const params = url.pathname.substring(1).split("/");

    if (url.pathname === "/") return data;

    data.form_id = params[0] ? params[0] : null;

    if (params[1] && Object.values(RouteNames).includes(params[1] as RouteNames)) {
        data.path = params[1];
    } else if (Object.values(RouteNames).includes(params[0] as RouteNames)) data.path = params[0];

    return data;
};

export const getFormIdFromUrl = (): IForm["_id"] => window.location.pathname.substring(1).split("/")[0];
